import React, { useEffect, useState } from 'react'
import Navber from '../Components/Navber.jsx';
import "../Styles/Transport_page.css"
import { FaBus, FaTrain, FaPlane, FaTaxi, FaCalendarAlt } from "react-icons/fa";
import Air_asia from "../Images/Air_asia.png"
import Indigo from "../Images/indi_go.png"
import Air_india from "../Images/AirIndiaA350.png"
import { Outlet, useNavigate } from 'react-router-dom';
import SelectSeatsScreen from "../Components/SelectSeatsScreen.jsx"
import Searchbar from './ExternalPage/ExternalPage.jsx';


function Transport_page() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("bus");
  return (
    <>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
      <div className="travel-wrapper" style={{backgroundColor:"#2C2C54",minHeight:"60vh"}}>
        {/* Background Image Banner */}
        <div className="banner">
          {/* Tabs */}
          {/* <div className="tabs">
            <div
              className={`tab ${activeTab === "bus" ? "active" : ""}`}
              onClick={() => {setActiveTab("bus");navigate("/transports")}}
            >
              <FaBus />
              <span>Bus</span>
            </div>
            <div
              className={`tab ${activeTab === "train" ? "active" : ""}`}
              onClick={() => setActiveTab("train")}
            >
              <FaTrain />
              <span>Train</span>
            </div>
            <div
              className={`tab ${activeTab === "plane" ? "active" : ""}`}
            onClick={() => {setActiveTab("plane");navigate("/search-page")}}
            >
              <FaPlane />
              <span>Aeroplane</span>
            </div>
            <div
              className={`tab ${activeTab === "cab" ? "active" : ""}`}
              onClick={() => { setActiveTab("cab"); navigate("/transports/cab") }}
            >
              <FaTaxi />
              <span>Cab</span>
            </div>
          </div> */}

          {/* Search Box */}
          {/* <div className="search-box">
            <input type="text" placeholder="From" />
            <input type="text" placeholder="To" />
            <div className="date-input">
              <input type="date" />
              <FaCalendarAlt className="calendar-icon" />
            </div>
            <button className="search-btn">Search</button>
          </div> */}
        </div>
        {/* <Outlet /> */}
        <Searchbar />

        {/* Airline Partners */}
        {/* <div className="partners">
          <h2>Experience Flying with our Airline Partners</h2>
          <div className="partners-list">
            <div className="partner-card">
              <img
                src={Air_asia}
                alt="AirAsia"
              />
            </div>
            <div className="partner-card">
              <img
                src={Indigo}
                alt="Indigo"
              />
            </div>
            <div className="partner-card">
              <img
                src={Air_asia}
                alt="Air India"
              />
            </div>
          </div>
        </div> */}

      </div>
      {/* <SelectSeatsScreen/> */}

    </>

  )
}

export default Transport_page